import { i18nFreeGift } from '@/views/promotion/freeGift/FreeGift';
import { getCurrency } from '@/views/promotion/freeGift/conditionList/FreeGiftCondition';
import { centerWinOptions } from '@/utils/commonUtils';

export  const mallNameColumns = [
  {
    header: 'GRID_TITLE_MALL_NAME', // 쇼핑몰
    name: 'mallName',
    align: 'center',
    minWidth: 75,
  }
];
export const partnerNameColumns = [
  {
    header: 'GRID_TITLE_PARTNER_NAME', // 파트너사
    name: 'partnerName',
    align: 'center',
    minWidth: 75,
  },
];
export const productInfoColumns = (url) => [
  {
    header: 'GRID_TITLE_PRODUCT_NO', // 상품번호
    name: 'productNo',
    align: 'center',
    minWidth: 75,
    formatter: ({ value }) => `<a href="#">${value}</a>`,
  },
  {
    header: 'GRID_TITLE_PRODUCT_NAME', // 상품명
    name: 'productName',
    align: 'center',
    minWidth: 75,
  },
];
export const productOptionInfoColumns = [
  {
    header: 'GRID_TITLE_OPTION_NO', // 옵션번호
    name: 'optionNo',
    align: 'center',
    minWidth: 75,
  },
  {
    header: 'GRID_TITLE_OPTION_LABEL', // 옵션명·옵션값
    name: 'optionLabel',
    align: 'center',
    minWidth: 75,
    formatter: ({ row }) => row?.optionNo ? `${row.optionName}: ${row.optionValue}` : `${row.productName}: ${row.productName}`
  },
];
export const giveAvailability = [
  {
    header: 'GRID_TITLE_GIVE_AVAILABILITY', // 지급가능여부
    name: 'giveAvailability',
    align: 'center',
    minWidth: 75,
    formatter: ({ row }) =>  row.freeGiftAvailable ? 'Y' : 'N'
  },
];
export const stockColumns = [
  {
    header: 'GRID_TITLE_STOCK', // 재고
    name: 'stockCnt',
    align: 'center',
    minWidth: 75,
    formatter: ({ value }) => value ? getCurrency(value) : '-'
  },
];
export const saleMethodTypeColumns = () => [
  {
    header: 'GRID_TITLE_SALE_METHOD_TYPE', // 판매방식
    name: 'saleMethodType',
    align: 'center',
    minWidth: 75,
    formatter: ({ value }) => i18nFreeGift(value)
  },
];
export const saleStatusColumns = () => [
  {
    header: 'GRID_TITLE_SALE_STATUS', // 판매상태
    name: 'saleStatusType',
    align: 'center',
    minWidth: 75,
    formatter: ({ value }) => i18nFreeGift(value)
  },
  {
    header: 'GRID_TITLE_SALE_STATUS_TYPE', // 판매설정
    name: 'saleSettingStatusType',
    align: 'center',
    minWidth: 75,
    formatter: ({ value }) => i18nFreeGift(value)
  },
];

export const promotionAvailabilityColumns = (type: 'freeGiftOption' | 'freeGift') => [
  {
    header: 'GRID_TITLE_PROMOTION_AVAILABILITY', // 프로모션 가능여부
    name: 'promotionAvailable',
    align: 'center',
    minWidth: 75,
    formatter: ({ value, row}) => {
      const uri = `/product/popup/modifyPromotion/${row.productNo}?type=${type}&optionNo=${row.optionNo}`;
      const size = centerWinOptions(795, 220);
      // return `<a href="${uri}" target="modifyPromotion" style="${size}">${value ? 'Y' : 'N'}</a>`
      return `<a href="javascript:onclick=window.open('${uri}', 'modifyPromotion', '${size}')">${value ? 'Y' : 'N'}</a>`
    }
  },
];
export const priceAndDiscountedPriceColumns = [
  {
    header: 'GRID_TITLE_PRICE_AND_DISCOUNT_PRICE', // 판매가/할인적용가
    name: 'price',
    align: 'center',
    minWidth: 75,
    formatter: ({ row }) => {
      const discount = row?.appliedAdditionalDiscountPrice;
      const salePrice = getCurrency(row.salePrice);
      return discount ? `${salePrice}/${getCurrency(discount)}` : `${salePrice}`
    }
  },
];
export const optionPriceColumns = [
  {
    header: 'GRID_TITLE_OPTION_PRICE', // 옵션판매가
    name: 'optionPrice',
    align: 'center',
    minWidth: 75,
    formatter: ({ value }) => getCurrency(value)
  },
];

export const commissionRateColumns = [
  {
    header: 'GRID_TITLE_COMMISSION_RATE', // 수수료율
    name: 'commissionRate',
    align: 'center',
    minWidth: 75,
    formatter: ({ value }) => value ? `${value}%` : '-'
  },
  {
    header: 'GRID_TITLE_SUPPLY_PRICE', // 공급가
    name: 'supplyPrice',
    align: 'center',
    minWidth: 75,
    formatter: ({ row }) => (row?.saleMethodType !== 'CONSIGNMENT' || !row.purchasePrice) ? '-' : getCurrency(row.purchasePrice)
  },
  {
    header: 'GRID_TITLE_PURCHASE_PRICE', // 매입가
    name: 'purchasePrice',
    align: 'center',
    minWidth: 75,
    formatter: ({ row }) => (row?.saleMethodType !== 'PURCHASE' || !row.purchasePrice) ? '-' : getCurrency(row.purchasePrice)
  },
];

export const i18nFreeGiftColumnsHeader = (columns) => columns.map(({ header, ...rest }) => ({ ...rest, header: i18nFreeGift(header) }))

export const gridPops = (url) => ({
  header: {
    height: 33,
  },
  options: {
    columnOptions: {
      resizable: true,
    },
    rowHeaders: ['checkbox'],
    rowHeight: 31,
    bodyHeight: 600,
    displayRowCount: 16,
    isInitialRequest: false,
    useClientSort: false,
    minRowHeight: 31,
    keyColumnName: 'optionNo',
    pageOptions: {
      page: 1,
      perPage: 30,
      totalCount: 0
    }
  },
  columns: i18nFreeGiftColumnsHeader([
    ...mallNameColumns,
    ...partnerNameColumns,
    ...productInfoColumns(url),
    ...productOptionInfoColumns,
    ...stockColumns,
    ...saleStatusColumns(),
    ...promotionAvailabilityColumns('freeGiftOption'),
    ...priceAndDiscountedPriceColumns,
    ...optionPriceColumns,
    ...commissionRateColumns,
  ]),
});

export const optionSearchKeys = [
  'mallNo',
  'mallName',
  'partnerNo',
  'partnerName',
  'productNo',
  'productName',
  'optionNo',
  'optionLabel',
  'promotionAvailable',
  'freeGiftAvailable',
  'stockCnt',
  'saleMethodType',
  'saleStatusType',
  'saleSettingStatusType',
  'appliedAdditionalDiscountPrice',
  'salePrice',
  'optionPrice',
  'optionName',
  'optionValue',
  'commissionRate',
  'purchasePrice'
];
